import AssignmentsListPage from '@/pages/assignments/list.tsx'

export default function ProjectAssignmentsPage() {
  return <AssignmentsListPage portalMode="project" />
}
